declare const __BUILD_ID__: string

export async function isStale(): Promise<boolean> {
  try {
    const res = await fetch('/version.json', { cache: 'no-store' })
    if (!res.ok) return false
    const { buildId } = await res.json()
    return buildId !== __BUILD_ID__
  } catch {
    // offline, or dev server answering with index.html instead of JSON
    return false
  }
}
